// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout global: cabeçalho no topo; abaixo, sidebar + área principal. O mapa é a
   superfície de fundo; os painéis flutuam sobre ele sem reformatar a casca. */

.casca-aplicacao {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--fundo-principal);
}

/* Região abaixo do cabeçalho: barra lateral à esquerda, coluna de conteúdo à direita. */
.casca-aplicacao__corpo {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: var(--largura-sidebar) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
}

.casca-aplicacao--colapsada .casca-aplicacao__corpo {
  grid-template-columns: var(--largura-sidebar-recolhida) minmax(0, 1fr);
}

.casca-aplicacao__coluna {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.casca-aplicacao__principal {
  flex: 1 1 0;
  /* Ocupa a altura útil; só passa dela (rolagem da coluna) se o conteúdo exigir. */
  min-height: min-content;
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--fundo-principal);
}

.casca-aplicacao__acoes-topo {
  flex: none;
  display: none;
  align-items: center;
  gap: var(--espaco-2);
  padding: var(--espaco-2) var(--espaco-5);
  background: var(--superficie);
  border-bottom: 1px solid var(--linha);
}

/* --- Cabeçalho da aplicação ---------------------------------------------- */

.cabecalho-aplicacao {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--espaco-4);
  height: var(--altura-topo);
  padding: 0 var(--espaco-5);
  background: var(--superficie);
  border-bottom: 1px solid var(--linha);
  z-index: 20;
}

.cabecalho-aplicacao__marca {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
  min-width: 0;
}

.cabecalho-aplicacao__marca-quadro {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--raio);
  background: var(--verde-institucional);
  color: var(--tinta-invertida);
}

.cabecalho-aplicacao__marca-quadro .topo__marca {
  color: inherit;
}

.cabecalho-aplicacao__textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.15;
}

.cabecalho-aplicacao__titulo {
  font-size: var(--texto-lg);
  font-weight: 700;
  color: var(--verde-institucional);
  letter-spacing: -0.01em;
}

.cabecalho-aplicacao__subtitulo {
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  font-weight: 500;
}

.cabecalho-aplicacao__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
}

.cabecalho-aplicacao__data {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  padding: 4px var(--espaco-3) 4px 4px;
  border: 1px solid transparent;
  border-radius: 999px;
  color: var(--verde-institucional);
  transition: background var(--transicao), border-color var(--transicao);
}

.cabecalho-aplicacao__data-icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--verde-suave);
  color: var(--verde-institucional);
}

.cabecalho-aplicacao__data-icone svg {
  width: 16px;
  height: 16px;
}

.cabecalho-aplicacao__data-textos {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}

.cabecalho-aplicacao__data-data {
  font-size: var(--texto-sm);
  font-weight: 600;
  color: var(--tinta);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.cabecalho-aplicacao__data-dia {
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
  text-transform: lowercase;
  white-space: nowrap;
}

/* Wrapper que abriga o botão do usuário e seu menu ancorado. */
.cabecalho-aplicacao__usuario {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.cabecalho-aplicacao__usuario-botao {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  padding: 4px 6px 4px 4px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 999px;
  color: var(--tinta);
  font: inherit;
  cursor: pointer;
  transition: background var(--transicao), border-color var(--transicao);
}

.cabecalho-aplicacao__usuario-botao:hover {
  background: var(--verde-suave);
  border-color: var(--linha);
}

.cabecalho-aplicacao__usuario-botao:focus-visible {
  outline: 2px solid var(--verde-primario);
  outline-offset: 2px;
}

.cabecalho-aplicacao__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--verde-suave);
  color: var(--verde-institucional);
  font-size: var(--texto-sm);
  font-weight: 700;
  letter-spacing: 0.02em;
  user-select: none;
}

.cabecalho-aplicacao__usuario-textos {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  text-align: left;
  min-width: 0;
  max-width: 180px;
}

.cabecalho-aplicacao__usuario-nome {
  font-size: var(--texto-sm);
  font-weight: 600;
  color: var(--tinta);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.cabecalho-aplicacao__usuario-rotulo {
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.cabecalho-aplicacao__usuario-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tinta-suave);
  margin-left: 2px;
  transition: transform var(--transicao);
}

.cabecalho-aplicacao__usuario-chevron svg {
  width: 14px;
  height: 14px;
}

.cabecalho-aplicacao__usuario-botao[aria-expanded='true'] .cabecalho-aplicacao__usuario-chevron {
  transform: rotate(180deg);
  color: var(--verde-institucional);
}

/* Menu ancorado: posicionado absolutamente a partir do wrapper do usuário. */
.cabecalho-aplicacao__menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: 248px;
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio);
  box-shadow: var(--sombra-flutuante);
  overflow: hidden;
  animation: cabecalho-aplicacao__menu-aparecer 120ms ease-out;
}

@keyframes cabecalho-aplicacao__menu-aparecer {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cabecalho-aplicacao__menu-cabecalho {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  padding: var(--espaco-3);
  background: var(--superficie-2);
  border-bottom: 1px solid var(--linha);
}

.cabecalho-aplicacao__avatar--menu {
  width: 32px;
  height: 32px;
  font-size: var(--texto-xs);
}

.cabecalho-aplicacao__menu-textos {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.cabecalho-aplicacao__menu-nome {
  font-size: var(--texto-sm);
  font-weight: 600;
  color: var(--tinta);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cabecalho-aplicacao__menu-rotulo {
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
}

.cabecalho-aplicacao__menu-lista {
  list-style: none;
  margin: 0;
  padding: var(--espaco-1);
}

.cabecalho-aplicacao__menu-item {
  display: block;
  width: 100%;
  padding: var(--espaco-2) var(--espaco-3);
  background: transparent;
  border: 0;
  border-radius: calc(var(--raio) - 2px);
  color: var(--tinta);
  font: inherit;
  font-size: var(--texto-sm);
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background var(--transicao), color var(--transicao);
}

.cabecalho-aplicacao__menu-item:not(:disabled):hover {
  background: var(--verde-suave);
  color: var(--verde-institucional);
}

.cabecalho-aplicacao__menu-item:focus-visible {
  outline: 2px solid var(--verde-primario);
  outline-offset: -2px;
}

.cabecalho-aplicacao__menu-item:disabled {
  color: var(--tinta-suave);
  cursor: not-allowed;
  opacity: 0.7;
}

.cabecalho-aplicacao__menu-item--perigoso:not(:disabled) {
  color: var(--erro);
}

.cabecalho-aplicacao__menu-item--perigoso:not(:disabled):hover {
  background: #fbe6e4;
  color: var(--erro);
}

.cabecalho-aplicacao__menu-separador {
  height: 1px;
  margin: var(--espaco-1) 0;
  background: var(--linha);
  list-style: none;
  padding: 0;
}

/* Em larguras reduzidas: primeiro o rótulo secundário do usuário, depois o
   dia da semana, por fim a data inteira. O usuário e o idioma permanecem. */
@media (max-width: 1180px) {
  .cabecalho-aplicacao__usuario-rotulo,
  .cabecalho-aplicacao__menu-rotulo {
    display: none;
  }
}

@media (max-width: 960px) {
  .cabecalho-aplicacao__data-dia {
    display: none;
  }
}

@media (max-width: 760px) {
  .cabecalho-aplicacao__data {
    display: none;
  }

  .cabecalho-aplicacao__usuario-textos {
    max-width: 120px;
  }
}

/* Seletor de idioma (PT | EN): compacto, fundo claro e texto verde escuro. */
.seletor-idioma {
  display: inline-flex;
  flex: none;
  padding: 2px;
  gap: 2px;
  background: var(--verde-suave);
  border: 1px solid var(--linha);
  border-radius: var(--raio);
}

.seletor-idioma__opcao {
  min-width: 32px;
  padding: 2px var(--espaco-2);
  background: transparent;
  border: 0;
  border-radius: calc(var(--raio) - 2px);
  color: var(--verde-institucional);
  font: inherit;
  font-size: var(--texto-xs);
  font-weight: 600;
  letter-spacing: 0.04em;
  cursor: pointer;
}

.seletor-idioma__opcao:hover:not(.seletor-idioma__opcao--ativa) {
  background: rgba(18, 63, 43, 0.1);
}

.seletor-idioma__opcao--ativa {
  background: var(--verde-institucional);
  color: var(--tinta-invertida);
  cursor: default;
}

.seletor-idioma__opcao:focus-visible {
  outline: 2px solid var(--verde-primario);
  outline-offset: 1px;
}

.pagina-login__idioma {
  position: absolute;
  top: var(--espaco-4);
  right: var(--espaco-5);
}

/* --- Barra lateral ------------------------------------------------------- */

.barra-lateral {
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--superficie);
  border-right: 1px solid var(--linha);
  padding: var(--espaco-3) var(--espaco-2);
  gap: var(--espaco-2);
  z-index: 15;
}

.barra-lateral__navegacao {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.barra-lateral__lista {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.barra-lateral__item {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
  padding: var(--espaco-2) var(--espaco-3);
  border-radius: var(--raio);
  color: var(--tinta-media);
  text-decoration: none;
  font-size: var(--texto-md);
  font-weight: 500;
  transition: background var(--transicao), color var(--transicao);
}

.barra-lateral__item:hover {
  background: var(--verde-suave);
  color: var(--verde-institucional);
}

.barra-lateral__item--ativo,
.barra-lateral__item--ativo:hover {
  background: var(--verde-primario);
  color: var(--tinta-invertida);
}

.barra-lateral__icone {
  flex: none;
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  color: currentColor;
}

.barra-lateral__icone svg {
  width: 18px;
  height: 18px;
}

.barra-lateral__rotulo {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.barra-lateral__recolher {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
  padding: var(--espaco-2) var(--espaco-3);
  border: none;
  background: transparent;
  border-radius: var(--raio);
  color: var(--tinta-suave);
  font: inherit;
  font-size: var(--texto-sm);
  cursor: pointer;
  text-align: left;
  transition: background var(--transicao), color var(--transicao);
}

.barra-lateral__recolher:hover {
  background: var(--superficie-2);
  color: var(--tinta);
}

.barra-lateral__recolher .barra-lateral__icone svg {
  transition: transform var(--transicao);
}

.barra-lateral--recolhida .barra-lateral__rotulo,
.barra-lateral--recolhida .barra-lateral__item,
.barra-lateral--recolhida .barra-lateral__recolher {
  justify-content: center;
  padding: var(--espaco-2);
}

.barra-lateral--recolhida .barra-lateral__rotulo {
  display: none;
}

.barra-lateral--recolhida .barra-lateral__recolher .barra-lateral__icone svg {
  transform: rotate(180deg);
}

/* --- Cabeçalho de página (dentro da casca) ------------------------------- */

.cabecalho-de-pagina {
  flex: none;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--espaco-4);
  padding: var(--espaco-5) var(--espaco-6) var(--espaco-3);
  background: var(--fundo-principal);
}

.cabecalho-de-pagina__textos {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
  min-width: 0;
}

.cabecalho-de-pagina__titulo {
  font-size: var(--texto-2xl);
  font-weight: 700;
  color: var(--verde-institucional);
  letter-spacing: -0.01em;
  margin: 0;
}

.cabecalho-de-pagina__subtitulo {
  color: var(--tinta-media);
  font-size: var(--texto-sm);
  margin: 0;
}

.cabecalho-de-pagina__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
}

/* --- Cartão compartilhado ----------------------------------------------- */

.cartao {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
  padding: var(--espaco-5);
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-card);
}

.cartao--sem-preenchimento {
  padding: 0;
}

.cartao--sem-preenchimento > :not(.cartao__cabecalho) {
  padding: var(--espaco-5);
}

.cartao__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--espaco-3);
  margin: calc(var(--espaco-5) * -1);
  margin-bottom: 0;
  padding: var(--espaco-3) var(--espaco-5);
  border-bottom: 1px solid var(--linha);
}

.cartao--sem-preenchimento .cartao__cabecalho {
  margin: 0;
  padding: var(--espaco-3) var(--espaco-5);
}

.cartao__titulo {
  font-size: var(--texto-md);
  font-weight: 600;
  color: var(--tinta);
  margin: 0;
}

.cartao__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  flex: none;
}

/* --- Compatibilidade: shell antigo e topo das páginas legadas ----------- */

.shell {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.topo {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--espaco-4);
  height: var(--altura-topo);
  padding: 0 var(--espaco-4);
  background: var(--papel);
  border-bottom: 1px solid var(--linha);
  z-index: 20;
}

.topo__identidade {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
  min-width: 0;
}

.topo__marca {
  flex: none;
  color: var(--realce);
}

.topo__textos {
  min-width: 0;
  line-height: 1.2;
}

.topo__titulo {
  font-size: var(--texto-md);
  font-weight: 600;
  letter-spacing: -0.01em;
}

.topo__subtitulo {
  display: block;
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topo__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-1);
  flex: none;
}

/* --- Palco do mapa (compartilhado) --------------------------------------- */

.palco {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
}

.mapa {
  position: absolute;
  inset: 0;
  background-color: var(--fundo-principal);
}

.mapa__tela {
  position: absolute;
  inset: 0;
}

/* --- Painéis flutuantes -------------------------------------------------- */

.flutuante {
  position: absolute;
  z-index: 5;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-flutuante);
  overflow: hidden;
}

/* Altura ajustada ao conteúdo: o painel não reserva área vazia sobre o mapa. */
.exploracao {
  left: var(--espaco-3);
  top: var(--espaco-3);
  width: var(--largura-exploracao);
  max-height: calc(100% - var(--espaco-3) * 2);
}

.inspetor {
  right: var(--espaco-3);
  top: var(--espaco-3);
  width: var(--largura-inspetor);
  max-height: calc(100% - var(--espaco-3) * 2);
}

/* A gaveta técnica não cobre os controles do mapa nem o painel de exploração. */
.gaveta {
  left: calc(var(--largura-exploracao) + var(--espaco-3) * 2);
  bottom: var(--espaco-3);
  width: min(560px, calc(100% - var(--largura-exploracao) - var(--espaco-3) * 4));
  max-height: 45%;
}

.chamada-flutuante {
  position: absolute;
  z-index: 5;
  left: var(--espaco-3);
  bottom: var(--espaco-3);
}

.aviso-do-mapa {
  position: absolute;
  z-index: 4;
  left: 50%;
  top: var(--espaco-3);
  transform: translateX(-50%);
  max-width: 420px;
  padding: var(--espaco-2) var(--espaco-3);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-left: 3px solid var(--alerta);
  border-radius: var(--raio);
  box-shadow: var(--sombra-flutuante);
  color: var(--tinta-media);
  font-size: var(--texto-xs);
  line-height: 1.5;
}

/* Telas menores: os painéis estreitam antes de o mapa ser sacrificado. */
@media (max-width: 1280px) {
  :root {
    --largura-exploracao: 360px;
    --largura-inspetor: 292px;
  }
}

@media (max-width: 900px) {
  :root {
    --largura-exploracao: 300px;
    --largura-inspetor: 260px;
  }

  .gaveta {
    left: var(--espaco-3);
    right: var(--espaco-3);
    width: auto;
  }
}

/* --- Login ----------------------------------------------------------------- */

.pagina-login {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  background: var(--fundo-principal);
}

.cartao-login {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-4);
  width: min(360px, calc(100vw - var(--espaco-5) * 2));
  padding: var(--espaco-5);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-flutuante);
}

.cartao-login__cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--espaco-2);
  text-align: center;
}

.cartao-login__titulo {
  font-size: var(--texto-lg);
  font-weight: 600;
}

.cartao-login__subtitulo {
  color: var(--tinta-suave);
  font-size: var(--texto-sm);
}

.cartao-login__erro {
  color: var(--erro);
  font-size: var(--texto-xs);
}

/* --- Home Operacional e Ingestão ------------------------------------------- */

.topo__usuario {
  color: var(--tinta-suave);
  font-size: var(--texto-sm);
}

.home-operacional,
.pagina-ingestao__corpo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.pagina-ingestao__corpo {
  padding: var(--espaco-3) var(--espaco-6) var(--espaco-6);
  gap: var(--espaco-5);
}

.home-operacional__cartoes {
  padding: var(--espaco-3) var(--espaco-6) var(--espaco-6);
}

/* --- Página de Ingestão: layout expandido ------------------------------- */

.pagina-ingestao {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: var(--espaco-3) var(--espaco-6) var(--espaco-6);
}

.pagina-ingestao__corpo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--espaco-5);
  width: 100%;
}

.home-operacional__cartoes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: var(--espaco-4);
  max-width: 720px;
  width: 100%;
  margin: 0;
}

.cartao-operacional {
  display: block;
  padding: var(--espaco-4);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  text-decoration: none;
  color: inherit;
  transition: border-color var(--transicao), box-shadow var(--transicao);
}

.cartao-operacional:hover {
  border-color: var(--linha-forte);
  box-shadow: var(--sombra-flutuante);
}

.cartao-operacional__titulo {
  font-size: var(--texto-md);
  font-weight: 600;
  margin: 0 0 var(--espaco-2);
}

.cartao-operacional__texto {
  color: var(--tinta-media);
  font-size: var(--texto-sm);
  margin: 0;
}

.cartao-operacional__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  margin-top: var(--espaco-3);
}

.pagina-ingestao__aviso {
  color: var(--tinta-suave);
  font-size: var(--texto-sm);
}

.secao-admin {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
  padding: var(--espaco-5);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-card);
}

.secao-admin__titulo {
  font-size: var(--texto-md);
  font-weight: 600;
  margin: 0;
}

.tabela-admin {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--texto-sm);
}

.tabela-admin th {
  text-align: left;
  padding: var(--espaco-2) var(--espaco-3);
  color: var(--tinta-suave);
  font-weight: 600;
  font-size: var(--texto-xs);
  border-bottom: 1px solid var(--linha);
}

.tabela-admin td {
  padding: var(--espaco-2) var(--espaco-3);
  border-bottom: 1px solid var(--linha);
}

.tabela-admin__linha-selecionavel {
  cursor: pointer;
}

.tabela-admin__linha-selecionavel:hover {
  background: var(--papel-2);
}

.tabela-admin__linha-selecionavel[data-selecionado='sim'] {
  background: var(--realce-fraco);
}

.etiqueta-status {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-1);
  padding: 2px var(--espaco-2);
  border-radius: 999px;
  font-size: var(--texto-xs);
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid transparent;
  white-space: nowrap;
}

.etiqueta-status::before {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  flex: none;
}

.etiqueta-status--running,
.etiqueta-status--pending {
  background: var(--verde-suave);
  color: var(--verde-primario);
  border-color: color-mix(in srgb, var(--verde-primario) 22%, transparent);
}

.etiqueta-status--success {
  background: #e4f3ec;
  color: var(--ok);
  border-color: color-mix(in srgb, var(--ok) 24%, transparent);
}

.etiqueta-status--partial {
  background: #fbeede;
  color: var(--alerta);
  border-color: color-mix(in srgb, var(--alerta) 24%, transparent);
}

.etiqueta-status--failed {
  background: #fbe6e4;
  color: var(--erro);
  border-color: color-mix(in srgb, var(--erro) 24%, transparent);
}

.etiqueta-status--cancelled {
  background: var(--superficie-3);
  color: var(--tinta-suave);
  border-color: var(--linha);
}

.lista-de-evidencias {
  margin: 0;
  padding-left: var(--espaco-4);
}

/* --- Nova ingestão: formulário premium ----------------------------------- */

.ingestao-form {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-4);
}

.ingestao-form__cabecalho {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--espaco-3);
}

.ingestao-form__titulo {
  margin: 0 0 var(--espaco-1);
  font-size: var(--texto-lg);
  font-weight: 700;
  color: var(--tinta);
}

.ingestao-form__subtitulo {
  margin: 0;
  color: var(--tinta-suave);
  font-size: var(--texto-sm);
}

.ingestao-form__cartao {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-6);
  padding: var(--espaco-6);
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-card);
}

.ingestao-form__secao {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
  padding-bottom: var(--espaco-6);
  border-bottom: 1px solid var(--linha);
}

.ingestao-form__secao:last-of-type {
  padding-bottom: 0;
  border-bottom: none;
}

.ingestao-form__secao-textos {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ingestao-form__secao-titulo {
  margin: 0;
  font-size: var(--texto-md);
  font-weight: 600;
  color: var(--tinta);
}

.ingestao-form__secao-descricao {
  margin: 0;
  font-size: var(--texto-sm);
  color: var(--tinta-suave);
}

.ingestao-form__grade {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--espaco-4);
}

@media (max-width: 720px) {
  .ingestao-form__grade {
    grid-template-columns: 1fr;
  }
}

.campo--largo {
  grid-column: 1 / -1;
}

.ingestao-form__dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--espaco-1);
  padding: var(--espaco-6);
  background: var(--fundo-principal);
  border: 1px dashed var(--linha-forte);
  border-radius: var(--raio-grande);
  text-align: center;
  cursor: pointer;
  transition: border-color var(--transicao), background var(--transicao);
}

.ingestao-form__dropzone:hover {
  border-color: var(--verde-primario);
  background: var(--verde-suave);
}

.ingestao-form__dropzone[data-preenchida='sim'] {
  border-style: solid;
  border-color: var(--verde-primario);
  background: var(--verde-suave);
}

.ingestao-form__dropzone-entrada {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.ingestao-form__dropzone-icone {
  display: flex;
  color: var(--verde-primario);
  margin-bottom: var(--espaco-1);
}

.ingestao-form__dropzone-texto {
  font-size: var(--texto-md);
  font-weight: 600;
  color: var(--tinta);
}

.ingestao-form__dropzone-formatos {
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
}

.ingestao-form__dropzone-arquivo-nome {
  font-size: var(--texto-md);
  font-weight: 600;
  color: var(--tinta);
  word-break: break-word;
}

.ingestao-form__dropzone-arquivo-tamanho {
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
}

.ingestao-form__dropzone-trocar {
  margin-top: var(--espaco-1);
  font-size: var(--texto-xs);
  color: var(--verde-primario);
  font-weight: 600;
}

.ingestao-form__erro {
  margin: 0;
  color: var(--erro);
  font-size: var(--texto-sm);
}

.ingestao-form__rodape {
  display: flex;
  justify-content: flex-end;
  gap: var(--espaco-2);
  padding-top: var(--espaco-2);
}

.botao--perigoso {
  color: var(--erro);
  border-color: var(--erro);
  background: var(--papel);
}

.botao--perigoso:hover:not(:disabled) {
  background: var(--erro);
  color: var(--papel);
}

/* Variante sólida: usada quando a ação destrutiva é a única ação primária do
   diálogo (confirmação de exclusão), nunca combinada com elementos verdes. */
button.botao--perigoso-solido {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  background: var(--erro);
  border-color: var(--erro);
  color: #ffffff;
  font-weight: 600;
}

.botao--perigoso-solido svg {
  width: 14px;
  height: 14px;
}

button.botao--perigoso-solido:hover:not(:disabled) {
  background: color-mix(in srgb, var(--erro) 85%, black);
  border-color: color-mix(in srgb, var(--erro) 85%, black);
  color: #ffffff;
}

.botao--perigoso-solido:focus-visible {
  outline: 2px solid var(--erro);
  outline-offset: 2px;
}

button.botao--perigoso-solido:disabled {
  background: color-mix(in srgb, var(--erro) 45%, var(--linha));
  border-color: color-mix(in srgb, var(--erro) 45%, var(--linha));
  color: #ffffff;
  opacity: 0.75;
  cursor: not-allowed;
}

.paginacao-historico {
  display: flex;
  justify-content: flex-end;
  gap: var(--espaco-2);
}

/* --- Home Operacional: painel premium ------------------------------------ */

.home-operacional {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-5);
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: var(--espaco-5) var(--espaco-6) var(--espaco-6);
}

/* A. Cabeçalho compacto da página */
.home-hero {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
  /* Aproxima os cartões do topo: compensa parte do espaçamento entre seções. */
  margin-bottom: calc(var(--espaco-2) * -1);
}

.home-hero__titulo {
  margin: 0;
  font-size: var(--texto-2xl);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.2;
  color: var(--verde-institucional);
}

.home-hero__subtitulo {
  margin: 0;
  font-size: var(--texto-md);
  color: var(--tinta-suave);
  max-width: 60ch;
  line-height: 1.45;
}

/* B. Acesso aos módulos */
.home-modulos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: var(--espaco-5);
  width: 100%;
}

.home-modulo {
  display: flex;
  align-items: flex-start;
  gap: var(--espaco-5);
  padding: var(--espaco-6);
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-card);
  transition: border-color var(--transicao), box-shadow var(--transicao), transform var(--transicao);
}

.home-modulo:hover {
  border-color: var(--linha-forte);
  box-shadow: var(--sombra-flutuante);
  transform: translateY(-1px);
}

.home-modulo__icone {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: var(--raio);
  background: var(--verde-primario);
  color: var(--tinta-invertida);
}

.home-modulo__icone svg {
  width: 26px;
  height: 26px;
}

.home-modulo__corpo {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
}

.home-modulo__categoria {
  margin: 0;
  font-size: var(--texto-xs);
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--verde-primario);
}

.home-modulo__titulo {
  margin: 0;
  font-size: var(--texto-xl);
  font-weight: 700;
  color: var(--tinta);
  letter-spacing: -0.01em;
}

.home-modulo__descricao {
  margin: 0;
  color: var(--tinta-media);
  font-size: var(--texto-md);
  line-height: 1.55;
}

.home-modulo__acoes {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  margin-top: auto;
  padding-top: var(--espaco-4);
}

/* Viewer em destaque: aparece primeiro e ganha identidade própria. */
.home-modulo--viewer {
  position: relative;
  order: -1;
  border: 2px solid var(--verde-primario);
  background:
    linear-gradient(
      145deg,
      rgba(233, 240, 232, 0.72) 0%,
      #ffffff 58%
    );
  box-shadow:
    0 2px 6px rgba(18, 63, 43, 0.06),
    0 12px 28px rgba(18, 63, 43, 0.09);
}

.home-modulo--viewer:hover {
  border-color: var(--verde-institucional);
  box-shadow:
    0 4px 10px rgba(18, 63, 43, 0.08),
    0 16px 32px rgba(18, 63, 43, 0.13);
}

.home-modulo--viewer .home-modulo__icone {
  background: var(--verde-institucional);
}

.home-modulo--viewer .home-modulo__titulo {
  color: var(--verde-institucional);
}

.home-modulo--ingestao .home-modulo__icone {
  background: var(--verde-suave);
  color: var(--verde-primario);
}

/* C. Capacidades operacionais */
.home-capacidades {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-4);
  width: 100%;
}

.home-capacidades__cabecalho {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
}

.home-capacidades__titulo {
  margin: 0;
  font-size: var(--texto-xl);
  font-weight: 700;
  color: var(--verde-institucional);
  letter-spacing: -0.01em;
}

.home-capacidades__subtitulo {
  margin: 0;
  color: var(--tinta-media);
  font-size: var(--texto-md);
  max-width: 70ch;
}

.home-capacidades__grade {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--espaco-4);
  width: 100%;
}

.home-capacidade {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
  padding: var(--espaco-5);
}

.home-capacidade__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--raio);
  background: var(--verde-suave);
  color: var(--verde-primario);
  margin-bottom: var(--espaco-2);
}

.home-capacidade__titulo {
  margin: 0;
  font-size: var(--texto-md);
  font-weight: 700;
  color: var(--tinta);
  letter-spacing: -0.005em;
}

.home-capacidade__texto {
  margin: 0;
  color: var(--tinta-media);
  font-size: var(--texto-sm);
  line-height: 1.55;
}

.home-capacidade__meta {
  margin: var(--espaco-2) 0 0;
  padding-top: var(--espaco-2);
  border-top: 1px solid var(--linha);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

/* D. Rodapé institucional */
.home-rodape {
  margin-top: var(--espaco-3);
  padding-top: var(--espaco-4);
  border-top: 1px solid var(--linha);
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

.home-rodape__linha {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  margin: 0;
}

.home-rodape__linha svg {
  width: 16px;
  height: 16px;
  color: var(--verde-primario);
}

/* Responsividade: o hero empilha em larguras estreitas, sem comprometer o conteúdo. */
@media (max-width: 720px) {
  .home-operacional {
    padding: var(--espaco-4) var(--espaco-4) var(--espaco-6);
  }

  .home-modulos {
    grid-template-columns: 1fr;
  }

  .home-modulo {
    flex-direction: column;
    align-items: flex-start;
    padding: var(--espaco-5);
  }
}

/* --- Histórico de Ingestões: apresentação premium ----------------------- */

.historico {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-4);
  width: 100%;
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-card);
  padding: var(--espaco-5) var(--espaco-5) var(--espaco-4);
}

.historico__cabecalho {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--espaco-4);
  padding-bottom: var(--espaco-3);
  border-bottom: 1px solid var(--linha);
}

.historico__titulos {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
  min-width: 0;
}

.historico__titulo {
  margin: 0;
  font-size: var(--texto-lg);
  font-weight: 700;
  color: var(--verde-institucional);
  letter-spacing: -0.01em;
}

.historico__subtitulo {
  margin: 0;
  font-size: var(--texto-sm);
  color: var(--tinta-media);
  max-width: 60ch;
}

.historico__paginador-info {
  margin: 0;
  flex: none;
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: 600;
}

.historico__paginador-info strong {
  color: var(--verde-institucional);
  font-weight: 700;
}

/* Mobile: a apresentação em cartões fica oculta por padrão; o breakpoint de
   760 px (ao fim desta seção) a exibe e oculta a tabela. */
.historico__cartoes {
  display: none;
}

/* A rolagem horizontal do wrapper é apenas rede de segurança para larguras em
   que as oito colunas não cabem; o dimensionamento normal é por conteúdo. */
.historico__tabela-wrapper {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--linha);
  border-radius: var(--raio);
  background: var(--superficie);
}

/* Layout automático: colunas compactas (\`historico__celula-compacta\`) ocupam o
   necessário ao seu conteúdo; Dataset e Camada publicada absorvem o restante. */
.historico__tabela {
  width: 100%;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;
  font-size: var(--texto-sm);
  color: var(--tinta);
}

.historico__tabela thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  text-align: left;
  padding: var(--espaco-3);
  background: var(--verde-suave);
  color: var(--verde-institucional);
  font-size: var(--texto-xs);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--linha);
  white-space: nowrap;
}

.historico__tabela tbody td {
  padding: var(--espaco-3);
  border-bottom: 1px solid var(--linha);
  vertical-align: middle;
  background: var(--superficie);
  transition: background var(--transicao);
  white-space: nowrap;
}

/* Colunas compactas: \`width: 1%\` + \`nowrap\` reduzem a coluna ao conteúdo, sem
   truncar números, datas, status ou botões. */
.historico__tabela .historico__celula-compacta {
  width: 1%;
  white-space: nowrap;
  overflow: visible;
}

/* Colunas elásticas: \`max-width: 0\` na própria célula permite o ellipsis, e
   \`min-width\` preserva um piso legível. Larguras em % são só a proporção entre
   as duas (somam 94%; as seis compactas reservam 1% cada). */
.historico__tabela .historico__celula-dataset,
.historico__tabela .historico__celula-camada {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.historico__tabela .historico__celula-dataset {
  width: 58%;
  min-width: 9rem;
}

.historico__tabela .historico__celula-camada {
  width: 36%;
  min-width: 7rem;
}

.historico__tabela tbody tr:last-child td {
  border-bottom: 0;
}

.historico__linha {
  cursor: pointer;
}

.historico__linha:hover td {
  background: var(--superficie-2);
}

.historico__linha[data-selecionado='sim'] td {
  background: var(--verde-suave);
}

.historico__linha[data-selecionado='sim']:hover td {
  background: var(--verde-suave);
  filter: brightness(0.98);
}

.historico__celula-numero {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: var(--tinta);
  font-weight: 500;
}

/* O seletor \`thead th\` (regra base, alinhada à esquerda) tem maior especificidade
   que \`.historico__celula-numero\`; este reforça o alinhamento à direita dos
   cabeçalhos numéricos, igual ao dos valores. */
.historico__tabela thead th.historico__celula-numero {
  text-align: right;
  color: var(--verde-institucional);
  font-weight: 700;
}

.historico__celula-data {
  white-space: nowrap;
  color: var(--tinta-media);
  font-variant-numeric: tabular-nums;
  font-size: var(--texto-sm);
  line-height: 1.25;
}

.historico__celula-data__linha {
  display: block;
}

.historico__celula-data__linha--hora {
  font-size: var(--texto-xs);
  color: var(--tinta-suave);
}

.historico__tabela tbody .historico__celula-camada {
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  color: var(--tinta-media);
}

.historico__dataset-titulo {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  color: var(--tinta);
}

.historico__tabela thead th.historico__celula-acoes {
  text-align: center;
}

/* O <td> de Ações mantém \`display: table-cell\`; o botão é centralizado por text-align. */
td.historico__celula-acoes {
  text-align: center;
}

.historico__botao-excluir {
  padding: 4px var(--espaco-3);
  font-size: var(--texto-xs);
  font-weight: 600;
}

.historico__paginacao {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--espaco-3);
  flex-wrap: wrap;
  padding-top: var(--espaco-3);
}

.historico__paginador-rodape {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  letter-spacing: 0.02em;
}

.historico__paginador-rodape strong {
  color: var(--verde-institucional);
  font-weight: 700;
}

.historico__paginador-separador {
  color: var(--linha-forte);
}

@media (max-width: 720px) {
  .historico {
    padding: var(--espaco-4);
  }

  .historico__cabecalho {
    flex-direction: column;
    align-items: flex-start;
  }

  .historico__paginacao {
    justify-content: flex-end;
  }
}

/* Cartões (mobile): um cartão por ingestão, renderizado a partir dos mesmos
   itens da tabela. Visíveis apenas no breakpoint abaixo. */
.historico__cartoes {
  list-style: none;
  margin: 0;
  padding: 0;
}

.historico__cartao {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
  min-width: 0;
  padding: var(--espaco-4);
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-card);
}

.historico__cartao[data-selecionado='sim'] {
  border-color: var(--verde-primario);
  box-shadow: 0 0 0 1px var(--verde-primario);
}

.historico__cartao-selecionar {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  background: transparent;
  border: 0;
  text-align: left;
  font: inherit;
  font-size: var(--texto-md);
  font-weight: 700;
  line-height: 1.35;
  color: var(--verde-institucional);
  overflow-wrap: anywhere;
  cursor: pointer;
}

.historico__cartao-selecionar:focus-visible {
  outline: 2px solid var(--verde-primario);
  outline-offset: 3px;
  border-radius: 4px;
}

.historico__cartao-campos {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
  margin: 0;
}

.historico__cartao-campo {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--espaco-3);
}

/* Rótulo com largura de conteúdo; valor ocupa o restante, alinhado à direita e
   com quebra segura de identificadores extensos (nunca uma palavra por linha). */
.historico__cartao-campo dt {
  flex: none;
  margin: 0;
  font-size: var(--texto-xs);
  font-weight: 600;
  color: var(--tinta-suave);
}

.historico__cartao-campo dd {
  flex: 1 1 0;
  min-width: 0;
  margin: 0;
  text-align: right;
  font-size: var(--texto-sm);
  font-variant-numeric: tabular-nums;
  color: var(--tinta);
  overflow-wrap: anywhere;
}

.historico__cartao-acoes {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--espaco-3);
  border-top: 1px solid var(--linha);
}

/* Até 760 px: troca a tabela pelos cartões. \`display: none\` remove a tabela da
   árvore de acessibilidade, evitando conteúdo duplicado para leitores de tela. */
@media (max-width: 760px) {
  .historico__tabela-wrapper {
    display: none;
  }

  .historico__cartoes {
    display: flex;
    flex-direction: column;
    gap: var(--espaco-3);
  }
}

/* --- Modal premium ------------------------------------------------------- */

.modal__backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--espaco-4);
  background: color-mix(in srgb, var(--verde-institucional) 38%, transparent);
  backdrop-filter: blur(2px);
}

.modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - var(--espaco-7));
  background: var(--superficie);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-flutuante);
  overflow: hidden;
}

.modal--compacto {
  max-width: 440px;
}

.modal__cabecalho {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--espaco-4);
  padding: var(--espaco-5) var(--espaco-5) var(--espaco-3);
  border-bottom: 1px solid var(--linha);
}

.modal__cabecalho-textos {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-1);
  min-width: 0;
}

.modal__titulo {
  margin: 0;
  font-size: var(--texto-lg);
  font-weight: 700;
  color: var(--verde-institucional);
  letter-spacing: -0.01em;
}

.modal__subtitulo {
  margin: 0;
  font-size: var(--texto-sm);
  color: var(--tinta-media);
}

.modal__fechar {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--raio);
  color: var(--tinta-suave);
  cursor: pointer;
  transition: background var(--transicao), color var(--transicao);
}

.modal__fechar:hover {
  background: var(--superficie-2);
  color: var(--tinta);
}

.modal__fechar svg {
  width: 16px;
  height: 16px;
}

.modal__corpo {
  padding: var(--espaco-4) var(--espaco-5);
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.modal__acoes {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--espaco-2);
  padding: var(--espaco-3) var(--espaco-5) var(--espaco-5);
  border-top: 1px solid var(--linha);
  background: var(--superficie-2);
}

/* Detalhes da execução dentro do modal */
.detalhe-execucao__grade {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: var(--espaco-4);
  row-gap: var(--espaco-3);
  align-items: baseline;
  font-size: var(--texto-sm);
}

.detalhe-execucao__rotulo {
  margin: 0;
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.detalhe-execucao__valor {
  margin: 0;
  color: var(--tinta);
  word-break: break-word;
}

.detalhe-execucao__valor--mono {
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  color: var(--tinta-media);
}

.detalhe-execucao__evidencias {
  margin: 0;
  padding-left: var(--espaco-4);
  color: var(--tinta-media);
  font-size: var(--texto-sm);
}

.detalhe-execucao__evidencias li {
  margin: var(--espaco-1) 0;
}

.detalhe-execucao__rodape-info {
  margin: var(--espaco-4) 0 0;
  padding-top: var(--espaco-3);
  border-top: 1px solid var(--linha);
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

.detalhe-execucao__erro {
  margin: 0 0 var(--espaco-3);
  padding: var(--espaco-3) var(--espaco-3);
  background: #fbe6e4;
  color: var(--erro);
  border: 1px solid color-mix(in srgb, var(--erro) 24%, transparent);
  border-radius: var(--raio);
  font-size: var(--texto-sm);
}

/* Modal de confirmação de exclusão: composição enxuta, sem cartões ou caixas
   coloridas — o vermelho aparece apenas no ícone de alerta e no botão
   destrutivo, o suficiente para comunicar o risco sem fragmentar o layout. */
.confirmacao-exclusao__cabecalho {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
  margin-bottom: var(--espaco-4);
}

.confirmacao-exclusao__alerta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: var(--raio);
  background: #fbe6e4;
  color: var(--erro);
}

.confirmacao-exclusao__alerta svg {
  width: 22px;
  height: 22px;
}

.confirmacao-exclusao__identificador {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.confirmacao-exclusao__identificador-rotulo {
  margin: 0;
  font-size: var(--texto-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--tinta-suave);
}

.confirmacao-exclusao__identificador-nome {
  margin: 0;
  font-size: var(--texto-md);
  font-weight: 600;
  color: var(--tinta);
  word-break: break-word;
}

.confirmacao-exclusao__aviso {
  margin: 0 0 var(--espaco-3);
  color: var(--tinta-media);
  font-size: var(--texto-sm);
  line-height: 1.55;
}

.confirmacao-exclusao__aviso strong {
  font-weight: 700;
}

.confirmacao-exclusao__erro {
  margin: var(--espaco-3) 0 0;
  padding: var(--espaco-3);
  background: #fbe6e4;
  color: var(--erro);
  border: 1px solid color-mix(in srgb, var(--erro) 24%, transparent);
  border-radius: var(--raio);
  font-size: var(--texto-sm);
}

.confirmacao-exclusao__atualizacao {
  margin: var(--espaco-3) 0 0;
  padding: var(--espaco-3);
  background: var(--superficie-3);
  color: var(--tinta-media);
  border: 1px solid var(--linha);
  border-radius: var(--raio);
  font-size: var(--texto-sm);
}

/* --- Viewer em telas estreitas: sidebar compacta ------------------------- */

@media (max-width: 760px) {
  .casca-aplicacao:has(.palco) .casca-aplicacao__corpo {
    grid-template-columns: 64px minmax(0, 1fr);
  }

  .casca-aplicacao:has(.palco) .barra-lateral {
    width: 64px;
    box-sizing: border-box;
    padding: 12px 8px;
  }

  .casca-aplicacao:has(.palco) .barra-lateral__item {
    justify-content: center;
    padding: 8px;
  }

  .casca-aplicacao:has(.palco) .barra-lateral__rotulo {
    display: none;
  }

  .casca-aplicacao:has(.palco) .barra-lateral__recolher {
    display: none;
  }

  .casca-aplicacao:has(.palco) .casca-aplicacao__coluna {
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;8EAC8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;AACpC;;AAEA,wFAAwF;AACxF;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,4DAA4D;EAC5D,kCAAkC;AACpC;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iFAAiF;EACjF,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,8EAA8E;;AAE9E;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,sEAAsE;AACxE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;4EAC4E;AAC5E;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;EACpC,wCAAwC;EACxC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8EAA8E;;AAE9E;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,wDAAwD;EACxD,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA,gFAAgF;AAChF;EACE,2DAA2D;EAC3D,uBAAuB;EACvB,+EAA+E;EAC/E,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,mCAAmC;EACnC,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,oDAAoD;EACpD,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,gFAAgF;;AAEhF;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;EACd,sEAAsE;AACxE;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;EAEE,8BAA8B;EAC9B,4BAA4B;EAC5B,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;6EAC6E;AAC7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,+DAA+D;EAC/D,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,wDAAwD;AAC1D;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,6EAA6E;EAC7E,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,kGAAkG;AACpG;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,SAAS;EACT,uCAAuC;EACvC;;;;;KAKG;EACH;;sCAEoC;AACtC;;AAEA;EACE,wCAAwC;EACxC;;sCAEoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,sFAAsF;AACtF;EACE;IACE,wDAAwD;EAC1D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;2DAC2D;AAC3D;EACE,aAAa;AACf;;AAEA;4EAC4E;AAC5E;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;gFACgF;AAChF;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,sBAAsB;EACtB,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;8CAC8C;AAC9C;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;6DAE6D;AAC7D;;EAEE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;gDAEgD;AAChD;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yFAAyF;AACzF;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;2DAC2D;AAC3D;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;iFACiF;AACjF;EACE,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;iFACiF;AACjF;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA,8EAA8E;;AAE9E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,2EAA2E;EAC3E,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,wDAAwD;EACxD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,wDAAwD;EACxD,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sCAAsC;EACtC,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,kEAAkE;EAClE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;6EAE6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,kEAAkE;EAClE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,8EAA8E;;AAE9E;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Layout global: cabeçalho no topo; abaixo, sidebar + área principal. O mapa é a\r\n   superfície de fundo; os painéis flutuam sobre ele sem reformatar a casca. */\r\n\r\n.casca-aplicacao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background: var(--fundo-principal);\r\n}\r\n\r\n/* Região abaixo do cabeçalho: barra lateral à esquerda, coluna de conteúdo à direita. */\r\n.casca-aplicacao__corpo {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: grid;\r\n  grid-template-columns: var(--largura-sidebar) minmax(0, 1fr);\r\n  grid-template-rows: minmax(0, 1fr);\r\n}\r\n\r\n.casca-aplicacao--colapsada .casca-aplicacao__corpo {\r\n  grid-template-columns: var(--largura-sidebar-recolhida) minmax(0, 1fr);\r\n}\r\n\r\n.casca-aplicacao__coluna {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.casca-aplicacao__principal {\r\n  flex: 1 1 0;\r\n  /* Ocupa a altura útil; só passa dela (rolagem da coluna) se o conteúdo exigir. */\r\n  min-height: min-content;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--fundo-principal);\r\n}\r\n\r\n.casca-aplicacao__acoes-topo {\r\n  flex: none;\r\n  display: none;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-2) var(--espaco-5);\r\n  background: var(--superficie);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n/* --- Cabeçalho da aplicação ---------------------------------------------- */\r\n\r\n.cabecalho-aplicacao {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-4);\r\n  height: var(--altura-topo);\r\n  padding: 0 var(--espaco-5);\r\n  background: var(--superficie);\r\n  border-bottom: 1px solid var(--linha);\r\n  z-index: 20;\r\n}\r\n\r\n.cabecalho-aplicacao__marca {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  min-width: 0;\r\n}\r\n\r\n.cabecalho-aplicacao__marca-quadro {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: var(--raio);\r\n  background: var(--verde-institucional);\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n.cabecalho-aplicacao__marca-quadro .topo__marca {\r\n  color: inherit;\r\n}\r\n\r\n.cabecalho-aplicacao__textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  line-height: 1.15;\r\n}\r\n\r\n.cabecalho-aplicacao__titulo {\r\n  font-size: var(--texto-lg);\r\n  font-weight: 700;\r\n  color: var(--verde-institucional);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.cabecalho-aplicacao__subtitulo {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  font-weight: 500;\r\n}\r\n\r\n.cabecalho-aplicacao__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n.cabecalho-aplicacao__data {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: 4px var(--espaco-3) 4px 4px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  color: var(--verde-institucional);\r\n  transition: background var(--transicao), border-color var(--transicao);\r\n}\r\n\r\n.cabecalho-aplicacao__data-icone {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: none;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  background: var(--verde-suave);\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.cabecalho-aplicacao__data-icone svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.cabecalho-aplicacao__data-textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.15;\r\n  min-width: 0;\r\n}\r\n\r\n.cabecalho-aplicacao__data-data {\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cabecalho-aplicacao__data-dia {\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n  text-transform: lowercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Wrapper que abriga o botão do usuário e seu menu ancorado. */\r\n.cabecalho-aplicacao__usuario {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-botao {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: 4px 6px 4px 4px;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  color: var(--tinta);\r\n  font: inherit;\r\n  cursor: pointer;\r\n  transition: background var(--transicao), border-color var(--transicao);\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-botao:hover {\r\n  background: var(--verde-suave);\r\n  border-color: var(--linha);\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-botao:focus-visible {\r\n  outline: 2px solid var(--verde-primario);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.cabecalho-aplicacao__avatar {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: none;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  background: var(--verde-suave);\r\n  color: var(--verde-institucional);\r\n  font-size: var(--texto-sm);\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  user-select: none;\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.15;\r\n  text-align: left;\r\n  min-width: 0;\r\n  max-width: 180px;\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-nome {\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-rotulo {\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n  letter-spacing: 0.04em;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-chevron {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--tinta-suave);\r\n  margin-left: 2px;\r\n  transition: transform var(--transicao);\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-chevron svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.cabecalho-aplicacao__usuario-botao[aria-expanded='true'] .cabecalho-aplicacao__usuario-chevron {\r\n  transform: rotate(180deg);\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n/* Menu ancorado: posicionado absolutamente a partir do wrapper do usuário. */\r\n.cabecalho-aplicacao__menu {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  z-index: 30;\r\n  width: 248px;\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n  box-shadow: var(--sombra-flutuante);\r\n  overflow: hidden;\r\n  animation: cabecalho-aplicacao__menu-aparecer 120ms ease-out;\r\n}\r\n\r\n@keyframes cabecalho-aplicacao__menu-aparecer {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.cabecalho-aplicacao__menu-cabecalho {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-3);\r\n  background: var(--superficie-2);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.cabecalho-aplicacao__avatar--menu {\r\n  width: 32px;\r\n  height: 32px;\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  line-height: 1.2;\r\n  min-width: 0;\r\n}\r\n\r\n.cabecalho-aplicacao__menu-nome {\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.cabecalho-aplicacao__menu-rotulo {\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-lista {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: var(--espaco-1);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  background: transparent;\r\n  border: 0;\r\n  border-radius: calc(var(--raio) - 2px);\r\n  color: var(--tinta);\r\n  font: inherit;\r\n  font-size: var(--texto-sm);\r\n  font-weight: 500;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background var(--transicao), color var(--transicao);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-item:not(:disabled):hover {\r\n  background: var(--verde-suave);\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-item:focus-visible {\r\n  outline: 2px solid var(--verde-primario);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.cabecalho-aplicacao__menu-item:disabled {\r\n  color: var(--tinta-suave);\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.cabecalho-aplicacao__menu-item--perigoso:not(:disabled) {\r\n  color: var(--erro);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-item--perigoso:not(:disabled):hover {\r\n  background: #fbe6e4;\r\n  color: var(--erro);\r\n}\r\n\r\n.cabecalho-aplicacao__menu-separador {\r\n  height: 1px;\r\n  margin: var(--espaco-1) 0;\r\n  background: var(--linha);\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n/* Em larguras reduzidas: primeiro o rótulo secundário do usuário, depois o\r\n   dia da semana, por fim a data inteira. O usuário e o idioma permanecem. */\r\n@media (max-width: 1180px) {\r\n  .cabecalho-aplicacao__usuario-rotulo,\r\n  .cabecalho-aplicacao__menu-rotulo {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .cabecalho-aplicacao__data-dia {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .cabecalho-aplicacao__data {\r\n    display: none;\r\n  }\r\n\r\n  .cabecalho-aplicacao__usuario-textos {\r\n    max-width: 120px;\r\n  }\r\n}\r\n\r\n/* Seletor de idioma (PT | EN): compacto, fundo claro e texto verde escuro. */\r\n.seletor-idioma {\r\n  display: inline-flex;\r\n  flex: none;\r\n  padding: 2px;\r\n  gap: 2px;\r\n  background: var(--verde-suave);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n}\r\n\r\n.seletor-idioma__opcao {\r\n  min-width: 32px;\r\n  padding: 2px var(--espaco-2);\r\n  background: transparent;\r\n  border: 0;\r\n  border-radius: calc(var(--raio) - 2px);\r\n  color: var(--verde-institucional);\r\n  font: inherit;\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.04em;\r\n  cursor: pointer;\r\n}\r\n\r\n.seletor-idioma__opcao:hover:not(.seletor-idioma__opcao--ativa) {\r\n  background: rgba(18, 63, 43, 0.1);\r\n}\r\n\r\n.seletor-idioma__opcao--ativa {\r\n  background: var(--verde-institucional);\r\n  color: var(--tinta-invertida);\r\n  cursor: default;\r\n}\r\n\r\n.seletor-idioma__opcao:focus-visible {\r\n  outline: 2px solid var(--verde-primario);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.pagina-login__idioma {\r\n  position: absolute;\r\n  top: var(--espaco-4);\r\n  right: var(--espaco-5);\r\n}\r\n\r\n/* --- Barra lateral ------------------------------------------------------- */\r\n\r\n.barra-lateral {\r\n  min-height: 0;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--superficie);\r\n  border-right: 1px solid var(--linha);\r\n  padding: var(--espaco-3) var(--espaco-2);\r\n  gap: var(--espaco-2);\r\n  z-index: 15;\r\n}\r\n\r\n.barra-lateral__navegacao {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.barra-lateral__lista {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.barra-lateral__item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-media);\r\n  text-decoration: none;\r\n  font-size: var(--texto-md);\r\n  font-weight: 500;\r\n  transition: background var(--transicao), color var(--transicao);\r\n}\r\n\r\n.barra-lateral__item:hover {\r\n  background: var(--verde-suave);\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.barra-lateral__item--ativo,\r\n.barra-lateral__item--ativo:hover {\r\n  background: var(--verde-primario);\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n.barra-lateral__icone {\r\n  flex: none;\r\n  display: inline-flex;\r\n  width: 18px;\r\n  height: 18px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: currentColor;\r\n}\r\n\r\n.barra-lateral__icone svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.barra-lateral__rotulo {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.barra-lateral__recolher {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  border: none;\r\n  background: transparent;\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-suave);\r\n  font: inherit;\r\n  font-size: var(--texto-sm);\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: background var(--transicao), color var(--transicao);\r\n}\r\n\r\n.barra-lateral__recolher:hover {\r\n  background: var(--superficie-2);\r\n  color: var(--tinta);\r\n}\r\n\r\n.barra-lateral__recolher .barra-lateral__icone svg {\r\n  transition: transform var(--transicao);\r\n}\r\n\r\n.barra-lateral--recolhida .barra-lateral__rotulo,\r\n.barra-lateral--recolhida .barra-lateral__item,\r\n.barra-lateral--recolhida .barra-lateral__recolher {\r\n  justify-content: center;\r\n  padding: var(--espaco-2);\r\n}\r\n\r\n.barra-lateral--recolhida .barra-lateral__rotulo {\r\n  display: none;\r\n}\r\n\r\n.barra-lateral--recolhida .barra-lateral__recolher .barra-lateral__icone svg {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* --- Cabeçalho de página (dentro da casca) ------------------------------- */\r\n\r\n.cabecalho-de-pagina {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-4);\r\n  padding: var(--espaco-5) var(--espaco-6) var(--espaco-3);\r\n  background: var(--fundo-principal);\r\n}\r\n\r\n.cabecalho-de-pagina__textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n  min-width: 0;\r\n}\r\n\r\n.cabecalho-de-pagina__titulo {\r\n  font-size: var(--texto-2xl);\r\n  font-weight: 700;\r\n  color: var(--verde-institucional);\r\n  letter-spacing: -0.01em;\r\n  margin: 0;\r\n}\r\n\r\n.cabecalho-de-pagina__subtitulo {\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-sm);\r\n  margin: 0;\r\n}\r\n\r\n.cabecalho-de-pagina__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n/* --- Cartão compartilhado ----------------------------------------------- */\r\n\r\n.cartao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-5);\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-card);\r\n}\r\n\r\n.cartao--sem-preenchimento {\r\n  padding: 0;\r\n}\r\n\r\n.cartao--sem-preenchimento > :not(.cartao__cabecalho) {\r\n  padding: var(--espaco-5);\r\n}\r\n\r\n.cartao__cabecalho {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-3);\r\n  margin: calc(var(--espaco-5) * -1);\r\n  margin-bottom: 0;\r\n  padding: var(--espaco-3) var(--espaco-5);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.cartao--sem-preenchimento .cartao__cabecalho {\r\n  margin: 0;\r\n  padding: var(--espaco-3) var(--espaco-5);\r\n}\r\n\r\n.cartao__titulo {\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n  margin: 0;\r\n}\r\n\r\n.cartao__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  flex: none;\r\n}\r\n\r\n/* --- Compatibilidade: shell antigo e topo das páginas legadas ----------- */\r\n\r\n.shell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.topo {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-4);\r\n  height: var(--altura-topo);\r\n  padding: 0 var(--espaco-4);\r\n  background: var(--papel);\r\n  border-bottom: 1px solid var(--linha);\r\n  z-index: 20;\r\n}\r\n\r\n.topo__identidade {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  min-width: 0;\r\n}\r\n\r\n.topo__marca {\r\n  flex: none;\r\n  color: var(--realce);\r\n}\r\n\r\n.topo__textos {\r\n  min-width: 0;\r\n  line-height: 1.2;\r\n}\r\n\r\n.topo__titulo {\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.topo__subtitulo {\r\n  display: block;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.topo__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-1);\r\n  flex: none;\r\n}\r\n\r\n/* --- Palco do mapa (compartilhado) --------------------------------------- */\r\n\r\n.palco {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n\r\n.mapa {\r\n  position: absolute;\r\n  inset: 0;\r\n  background-color: var(--fundo-principal);\r\n}\r\n\r\n.mapa__tela {\r\n  position: absolute;\r\n  inset: 0;\r\n}\r\n\r\n/* --- Painéis flutuantes -------------------------------------------------- */\r\n\r\n.flutuante {\r\n  position: absolute;\r\n  z-index: 5;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-flutuante);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Altura ajustada ao conteúdo: o painel não reserva área vazia sobre o mapa. */\r\n.exploracao {\r\n  left: var(--espaco-3);\r\n  top: var(--espaco-3);\r\n  width: var(--largura-exploracao);\r\n  max-height: calc(100% - var(--espaco-3) * 2);\r\n}\r\n\r\n.inspetor {\r\n  right: var(--espaco-3);\r\n  top: var(--espaco-3);\r\n  width: var(--largura-inspetor);\r\n  max-height: calc(100% - var(--espaco-3) * 2);\r\n}\r\n\r\n/* A gaveta técnica não cobre os controles do mapa nem o painel de exploração. */\r\n.gaveta {\r\n  left: calc(var(--largura-exploracao) + var(--espaco-3) * 2);\r\n  bottom: var(--espaco-3);\r\n  width: min(560px, calc(100% - var(--largura-exploracao) - var(--espaco-3) * 4));\r\n  max-height: 45%;\r\n}\r\n\r\n.chamada-flutuante {\r\n  position: absolute;\r\n  z-index: 5;\r\n  left: var(--espaco-3);\r\n  bottom: var(--espaco-3);\r\n}\r\n\r\n.aviso-do-mapa {\r\n  position: absolute;\r\n  z-index: 4;\r\n  left: 50%;\r\n  top: var(--espaco-3);\r\n  transform: translateX(-50%);\r\n  max-width: 420px;\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-left: 3px solid var(--alerta);\r\n  border-radius: var(--raio);\r\n  box-shadow: var(--sombra-flutuante);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-xs);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Telas menores: os painéis estreitam antes de o mapa ser sacrificado. */\r\n@media (max-width: 1280px) {\r\n  :root {\r\n    --largura-exploracao: 360px;\r\n    --largura-inspetor: 292px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  :root {\r\n    --largura-exploracao: 300px;\r\n    --largura-inspetor: 260px;\r\n  }\r\n\r\n  .gaveta {\r\n    left: var(--espaco-3);\r\n    right: var(--espaco-3);\r\n    width: auto;\r\n  }\r\n}\r\n\r\n/* --- Login ----------------------------------------------------------------- */\r\n\r\n.pagina-login {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100%;\r\n  background: var(--fundo-principal);\r\n}\r\n\r\n.cartao-login {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-4);\r\n  width: min(360px, calc(100vw - var(--espaco-5) * 2));\r\n  padding: var(--espaco-5);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-flutuante);\r\n}\r\n\r\n.cartao-login__cabecalho {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  text-align: center;\r\n}\r\n\r\n.cartao-login__titulo {\r\n  font-size: var(--texto-lg);\r\n  font-weight: 600;\r\n}\r\n\r\n.cartao-login__subtitulo {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.cartao-login__erro {\r\n  color: var(--erro);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n/* --- Home Operacional e Ingestão ------------------------------------------- */\r\n\r\n.topo__usuario {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.home-operacional,\r\n.pagina-ingestao__corpo {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.pagina-ingestao__corpo {\r\n  padding: var(--espaco-3) var(--espaco-6) var(--espaco-6);\r\n  gap: var(--espaco-5);\r\n}\r\n\r\n.home-operacional__cartoes {\r\n  padding: var(--espaco-3) var(--espaco-6) var(--espaco-6);\r\n}\r\n\r\n/* --- Página de Ingestão: layout expandido ------------------------------- */\r\n\r\n.pagina-ingestao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  width: 100%;\r\n  max-width: 1320px;\r\n  margin: 0 auto;\r\n  padding: var(--espaco-3) var(--espaco-6) var(--espaco-6);\r\n}\r\n\r\n.pagina-ingestao__corpo {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-5);\r\n  width: 100%;\r\n}\r\n\r\n.home-operacional__cartoes {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n  gap: var(--espaco-4);\r\n  max-width: 720px;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.cartao-operacional {\r\n  display: block;\r\n  padding: var(--espaco-4);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  text-decoration: none;\r\n  color: inherit;\r\n  transition: border-color var(--transicao), box-shadow var(--transicao);\r\n}\r\n\r\n.cartao-operacional:hover {\r\n  border-color: var(--linha-forte);\r\n  box-shadow: var(--sombra-flutuante);\r\n}\r\n\r\n.cartao-operacional__titulo {\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  margin: 0 0 var(--espaco-2);\r\n}\r\n\r\n.cartao-operacional__texto {\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-sm);\r\n  margin: 0;\r\n}\r\n\r\n.cartao-operacional__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  margin-top: var(--espaco-3);\r\n}\r\n\r\n.pagina-ingestao__aviso {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.secao-admin {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-5);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-card);\r\n}\r\n\r\n.secao-admin__titulo {\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.tabela-admin {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.tabela-admin th {\r\n  text-align: left;\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  color: var(--tinta-suave);\r\n  font-weight: 600;\r\n  font-size: var(--texto-xs);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.tabela-admin td {\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.tabela-admin__linha-selecionavel {\r\n  cursor: pointer;\r\n}\r\n\r\n.tabela-admin__linha-selecionavel:hover {\r\n  background: var(--papel-2);\r\n}\r\n\r\n.tabela-admin__linha-selecionavel[data-selecionado='sim'] {\r\n  background: var(--realce-fraco);\r\n}\r\n\r\n.etiqueta-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-1);\r\n  padding: 2px var(--espaco-2);\r\n  border-radius: 999px;\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  border: 1px solid transparent;\r\n  white-space: nowrap;\r\n}\r\n\r\n.etiqueta-status::before {\r\n  content: '';\r\n  display: inline-block;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n  flex: none;\r\n}\r\n\r\n.etiqueta-status--running,\r\n.etiqueta-status--pending {\r\n  background: var(--verde-suave);\r\n  color: var(--verde-primario);\r\n  border-color: color-mix(in srgb, var(--verde-primario) 22%, transparent);\r\n}\r\n\r\n.etiqueta-status--success {\r\n  background: #e4f3ec;\r\n  color: var(--ok);\r\n  border-color: color-mix(in srgb, var(--ok) 24%, transparent);\r\n}\r\n\r\n.etiqueta-status--partial {\r\n  background: #fbeede;\r\n  color: var(--alerta);\r\n  border-color: color-mix(in srgb, var(--alerta) 24%, transparent);\r\n}\r\n\r\n.etiqueta-status--failed {\r\n  background: #fbe6e4;\r\n  color: var(--erro);\r\n  border-color: color-mix(in srgb, var(--erro) 24%, transparent);\r\n}\r\n\r\n.etiqueta-status--cancelled {\r\n  background: var(--superficie-3);\r\n  color: var(--tinta-suave);\r\n  border-color: var(--linha);\r\n}\r\n\r\n.lista-de-evidencias {\r\n  margin: 0;\r\n  padding-left: var(--espaco-4);\r\n}\r\n\r\n/* --- Nova ingestão: formulário premium ----------------------------------- */\r\n\r\n.ingestao-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-4);\r\n}\r\n\r\n.ingestao-form__cabecalho {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n.ingestao-form__titulo {\r\n  margin: 0 0 var(--espaco-1);\r\n  font-size: var(--texto-lg);\r\n  font-weight: 700;\r\n  color: var(--tinta);\r\n}\r\n\r\n.ingestao-form__subtitulo {\r\n  margin: 0;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.ingestao-form__cartao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-6);\r\n  padding: var(--espaco-6);\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-card);\r\n}\r\n\r\n.ingestao-form__secao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n  padding-bottom: var(--espaco-6);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.ingestao-form__secao:last-of-type {\r\n  padding-bottom: 0;\r\n  border-bottom: none;\r\n}\r\n\r\n.ingestao-form__secao-textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.ingestao-form__secao-titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n}\r\n\r\n.ingestao-form__secao-descricao {\r\n  margin: 0;\r\n  font-size: var(--texto-sm);\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.ingestao-form__grade {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: var(--espaco-4);\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .ingestao-form__grade {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.campo--largo {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.ingestao-form__dropzone {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--espaco-1);\r\n  padding: var(--espaco-6);\r\n  background: var(--fundo-principal);\r\n  border: 1px dashed var(--linha-forte);\r\n  border-radius: var(--raio-grande);\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: border-color var(--transicao), background var(--transicao);\r\n}\r\n\r\n.ingestao-form__dropzone:hover {\r\n  border-color: var(--verde-primario);\r\n  background: var(--verde-suave);\r\n}\r\n\r\n.ingestao-form__dropzone[data-preenchida='sim'] {\r\n  border-style: solid;\r\n  border-color: var(--verde-primario);\r\n  background: var(--verde-suave);\r\n}\r\n\r\n.ingestao-form__dropzone-entrada {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.ingestao-form__dropzone-icone {\r\n  display: flex;\r\n  color: var(--verde-primario);\r\n  margin-bottom: var(--espaco-1);\r\n}\r\n\r\n.ingestao-form__dropzone-texto {\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n}\r\n\r\n.ingestao-form__dropzone-formatos {\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.ingestao-form__dropzone-arquivo-nome {\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n  word-break: break-word;\r\n}\r\n\r\n.ingestao-form__dropzone-arquivo-tamanho {\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.ingestao-form__dropzone-trocar {\r\n  margin-top: var(--espaco-1);\r\n  font-size: var(--texto-xs);\r\n  color: var(--verde-primario);\r\n  font-weight: 600;\r\n}\r\n\r\n.ingestao-form__erro {\r\n  margin: 0;\r\n  color: var(--erro);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.ingestao-form__rodape {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: var(--espaco-2);\r\n  padding-top: var(--espaco-2);\r\n}\r\n\r\n.botao--perigoso {\r\n  color: var(--erro);\r\n  border-color: var(--erro);\r\n  background: var(--papel);\r\n}\r\n\r\n.botao--perigoso:hover:not(:disabled) {\r\n  background: var(--erro);\r\n  color: var(--papel);\r\n}\r\n\r\n/* Variante sólida: usada quando a ação destrutiva é a única ação primária do\r\n   diálogo (confirmação de exclusão), nunca combinada com elementos verdes. */\r\nbutton.botao--perigoso-solido {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  background: var(--erro);\r\n  border-color: var(--erro);\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n}\r\n\r\n.botao--perigoso-solido svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\nbutton.botao--perigoso-solido:hover:not(:disabled) {\r\n  background: color-mix(in srgb, var(--erro) 85%, black);\r\n  border-color: color-mix(in srgb, var(--erro) 85%, black);\r\n  color: #ffffff;\r\n}\r\n\r\n.botao--perigoso-solido:focus-visible {\r\n  outline: 2px solid var(--erro);\r\n  outline-offset: 2px;\r\n}\r\n\r\nbutton.botao--perigoso-solido:disabled {\r\n  background: color-mix(in srgb, var(--erro) 45%, var(--linha));\r\n  border-color: color-mix(in srgb, var(--erro) 45%, var(--linha));\r\n  color: #ffffff;\r\n  opacity: 0.75;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.paginacao-historico {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n/* --- Home Operacional: painel premium ------------------------------------ */\r\n\r\n.home-operacional {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-5);\r\n  width: 100%;\r\n  max-width: 1240px;\r\n  margin: 0 auto;\r\n  padding: var(--espaco-5) var(--espaco-6) var(--espaco-6);\r\n}\r\n\r\n/* A. Cabeçalho compacto da página */\r\n.home-hero {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n  /* Aproxima os cartões do topo: compensa parte do espaçamento entre seções. */\r\n  margin-bottom: calc(var(--espaco-2) * -1);\r\n}\r\n\r\n.home-hero__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-2xl);\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  line-height: 1.2;\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.home-hero__subtitulo {\r\n  margin: 0;\r\n  font-size: var(--texto-md);\r\n  color: var(--tinta-suave);\r\n  max-width: 60ch;\r\n  line-height: 1.45;\r\n}\r\n\r\n/* B. Acesso aos módulos */\r\n.home-modulos {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\r\n  gap: var(--espaco-5);\r\n  width: 100%;\r\n}\r\n\r\n.home-modulo {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: var(--espaco-5);\r\n  padding: var(--espaco-6);\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-card);\r\n  transition: border-color var(--transicao), box-shadow var(--transicao), transform var(--transicao);\r\n}\r\n\r\n.home-modulo:hover {\r\n  border-color: var(--linha-forte);\r\n  box-shadow: var(--sombra-flutuante);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.home-modulo__icone {\r\n  flex: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: var(--raio);\r\n  background: var(--verde-primario);\r\n  color: var(--tinta-invertida);\r\n}\r\n\r\n.home-modulo__icone svg {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n\r\n.home-modulo__corpo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n  min-width: 0;\r\n  flex: 1 1 auto;\r\n  align-self: stretch;\r\n}\r\n\r\n.home-modulo__categoria {\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.1em;\r\n  text-transform: uppercase;\r\n  color: var(--verde-primario);\r\n}\r\n\r\n.home-modulo__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-xl);\r\n  font-weight: 700;\r\n  color: var(--tinta);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.home-modulo__descricao {\r\n  margin: 0;\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-md);\r\n  line-height: 1.55;\r\n}\r\n\r\n.home-modulo__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  margin-top: auto;\r\n  padding-top: var(--espaco-4);\r\n}\r\n\r\n/* Viewer em destaque: aparece primeiro e ganha identidade própria. */\r\n.home-modulo--viewer {\r\n  position: relative;\r\n  order: -1;\r\n  border: 2px solid var(--verde-primario);\r\n  background:\r\n    linear-gradient(\r\n      145deg,\r\n      rgba(233, 240, 232, 0.72) 0%,\r\n      #ffffff 58%\r\n    );\r\n  box-shadow:\r\n    0 2px 6px rgba(18, 63, 43, 0.06),\r\n    0 12px 28px rgba(18, 63, 43, 0.09);\r\n}\r\n\r\n.home-modulo--viewer:hover {\r\n  border-color: var(--verde-institucional);\r\n  box-shadow:\r\n    0 4px 10px rgba(18, 63, 43, 0.08),\r\n    0 16px 32px rgba(18, 63, 43, 0.13);\r\n}\r\n\r\n.home-modulo--viewer .home-modulo__icone {\r\n  background: var(--verde-institucional);\r\n}\r\n\r\n.home-modulo--viewer .home-modulo__titulo {\r\n  color: var(--verde-institucional);\r\n}\r\n\r\n.home-modulo--ingestao .home-modulo__icone {\r\n  background: var(--verde-suave);\r\n  color: var(--verde-primario);\r\n}\r\n\r\n/* C. Capacidades operacionais */\r\n.home-capacidades {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-4);\r\n  width: 100%;\r\n}\r\n\r\n.home-capacidades__cabecalho {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n}\r\n\r\n.home-capacidades__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-xl);\r\n  font-weight: 700;\r\n  color: var(--verde-institucional);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.home-capacidades__subtitulo {\r\n  margin: 0;\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-md);\r\n  max-width: 70ch;\r\n}\r\n\r\n.home-capacidades__grade {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: var(--espaco-4);\r\n  width: 100%;\r\n}\r\n\r\n.home-capacidade {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-5);\r\n}\r\n\r\n.home-capacidade__icone {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: var(--raio);\r\n  background: var(--verde-suave);\r\n  color: var(--verde-primario);\r\n  margin-bottom: var(--espaco-2);\r\n}\r\n\r\n.home-capacidade__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-md);\r\n  font-weight: 700;\r\n  color: var(--tinta);\r\n  letter-spacing: -0.005em;\r\n}\r\n\r\n.home-capacidade__texto {\r\n  margin: 0;\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-sm);\r\n  line-height: 1.55;\r\n}\r\n\r\n.home-capacidade__meta {\r\n  margin: var(--espaco-2) 0 0;\r\n  padding-top: var(--espaco-2);\r\n  border-top: 1px solid var(--linha);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  font-weight: 500;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* D. Rodapé institucional */\r\n.home-rodape {\r\n  margin-top: var(--espaco-3);\r\n  padding-top: var(--espaco-4);\r\n  border-top: 1px solid var(--linha);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.home-rodape__linha {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  margin: 0;\r\n}\r\n\r\n.home-rodape__linha svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  color: var(--verde-primario);\r\n}\r\n\r\n/* Responsividade: o hero empilha em larguras estreitas, sem comprometer o conteúdo. */\r\n@media (max-width: 720px) {\r\n  .home-operacional {\r\n    padding: var(--espaco-4) var(--espaco-4) var(--espaco-6);\r\n  }\r\n\r\n  .home-modulos {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .home-modulo {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    padding: var(--espaco-5);\r\n  }\r\n}\r\n\r\n/* --- Histórico de Ingestões: apresentação premium ----------------------- */\r\n\r\n.historico {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-4);\r\n  width: 100%;\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-card);\r\n  padding: var(--espaco-5) var(--espaco-5) var(--espaco-4);\r\n}\r\n\r\n.historico__cabecalho {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-4);\r\n  padding-bottom: var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.historico__titulos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n  min-width: 0;\r\n}\r\n\r\n.historico__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-lg);\r\n  font-weight: 700;\r\n  color: var(--verde-institucional);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.historico__subtitulo {\r\n  margin: 0;\r\n  font-size: var(--texto-sm);\r\n  color: var(--tinta-media);\r\n  max-width: 60ch;\r\n}\r\n\r\n.historico__paginador-info {\r\n  margin: 0;\r\n  flex: none;\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n}\r\n\r\n.historico__paginador-info strong {\r\n  color: var(--verde-institucional);\r\n  font-weight: 700;\r\n}\r\n\r\n/* Mobile: a apresentação em cartões fica oculta por padrão; o breakpoint de\r\n   760 px (ao fim desta seção) a exibe e oculta a tabela. */\r\n.historico__cartoes {\r\n  display: none;\r\n}\r\n\r\n/* A rolagem horizontal do wrapper é apenas rede de segurança para larguras em\r\n   que as oito colunas não cabem; o dimensionamento normal é por conteúdo. */\r\n.historico__tabela-wrapper {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n  background: var(--superficie);\r\n}\r\n\r\n/* Layout automático: colunas compactas (`historico__celula-compacta`) ocupam o\r\n   necessário ao seu conteúdo; Dataset e Camada publicada absorvem o restante. */\r\n.historico__tabela {\r\n  width: 100%;\r\n  table-layout: auto;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  font-size: var(--texto-sm);\r\n  color: var(--tinta);\r\n}\r\n\r\n.historico__tabela thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  text-align: left;\r\n  padding: var(--espaco-3);\r\n  background: var(--verde-suave);\r\n  color: var(--verde-institucional);\r\n  font-size: var(--texto-xs);\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  border-bottom: 1px solid var(--linha);\r\n  white-space: nowrap;\r\n}\r\n\r\n.historico__tabela tbody td {\r\n  padding: var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n  vertical-align: middle;\r\n  background: var(--superficie);\r\n  transition: background var(--transicao);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Colunas compactas: `width: 1%` + `nowrap` reduzem a coluna ao conteúdo, sem\r\n   truncar números, datas, status ou botões. */\r\n.historico__tabela .historico__celula-compacta {\r\n  width: 1%;\r\n  white-space: nowrap;\r\n  overflow: visible;\r\n}\r\n\r\n/* Colunas elásticas: `max-width: 0` na própria célula permite o ellipsis, e\r\n   `min-width` preserva um piso legível. Larguras em % são só a proporção entre\r\n   as duas (somam 94%; as seis compactas reservam 1% cada). */\r\n.historico__tabela .historico__celula-dataset,\r\n.historico__tabela .historico__celula-camada {\r\n  max-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.historico__tabela .historico__celula-dataset {\r\n  width: 58%;\r\n  min-width: 9rem;\r\n}\r\n\r\n.historico__tabela .historico__celula-camada {\r\n  width: 36%;\r\n  min-width: 7rem;\r\n}\r\n\r\n.historico__tabela tbody tr:last-child td {\r\n  border-bottom: 0;\r\n}\r\n\r\n.historico__linha {\r\n  cursor: pointer;\r\n}\r\n\r\n.historico__linha:hover td {\r\n  background: var(--superficie-2);\r\n}\r\n\r\n.historico__linha[data-selecionado='sim'] td {\r\n  background: var(--verde-suave);\r\n}\r\n\r\n.historico__linha[data-selecionado='sim']:hover td {\r\n  background: var(--verde-suave);\r\n  filter: brightness(0.98);\r\n}\r\n\r\n.historico__celula-numero {\r\n  text-align: right;\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n  color: var(--tinta);\r\n  font-weight: 500;\r\n}\r\n\r\n/* O seletor `thead th` (regra base, alinhada à esquerda) tem maior especificidade\r\n   que `.historico__celula-numero`; este reforça o alinhamento à direita dos\r\n   cabeçalhos numéricos, igual ao dos valores. */\r\n.historico__tabela thead th.historico__celula-numero {\r\n  text-align: right;\r\n  color: var(--verde-institucional);\r\n  font-weight: 700;\r\n}\r\n\r\n.historico__celula-data {\r\n  white-space: nowrap;\r\n  color: var(--tinta-media);\r\n  font-variant-numeric: tabular-nums;\r\n  font-size: var(--texto-sm);\r\n  line-height: 1.25;\r\n}\r\n\r\n.historico__celula-data__linha {\r\n  display: block;\r\n}\r\n\r\n.historico__celula-data__linha--hora {\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.historico__tabela tbody .historico__celula-camada {\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-media);\r\n}\r\n\r\n.historico__dataset-titulo {\r\n  display: block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-weight: 500;\r\n  color: var(--tinta);\r\n}\r\n\r\n.historico__tabela thead th.historico__celula-acoes {\r\n  text-align: center;\r\n}\r\n\r\n/* O <td> de Ações mantém `display: table-cell`; o botão é centralizado por text-align. */\r\ntd.historico__celula-acoes {\r\n  text-align: center;\r\n}\r\n\r\n.historico__botao-excluir {\r\n  padding: 4px var(--espaco-3);\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n}\r\n\r\n.historico__paginacao {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-3);\r\n  flex-wrap: wrap;\r\n  padding-top: var(--espaco-3);\r\n}\r\n\r\n.historico__paginador-rodape {\r\n  margin: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.historico__paginador-rodape strong {\r\n  color: var(--verde-institucional);\r\n  font-weight: 700;\r\n}\r\n\r\n.historico__paginador-separador {\r\n  color: var(--linha-forte);\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .historico {\r\n    padding: var(--espaco-4);\r\n  }\r\n\r\n  .historico__cabecalho {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .historico__paginacao {\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\n/* Cartões (mobile): um cartão por ingestão, renderizado a partir dos mesmos\r\n   itens da tabela. Visíveis apenas no breakpoint abaixo. */\r\n.historico__cartoes {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.historico__cartao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n  min-width: 0;\r\n  padding: var(--espaco-4);\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-card);\r\n}\r\n\r\n.historico__cartao[data-selecionado='sim'] {\r\n  border-color: var(--verde-primario);\r\n  box-shadow: 0 0 0 1px var(--verde-primario);\r\n}\r\n\r\n.historico__cartao-selecionar {\r\n  display: block;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  background: transparent;\r\n  border: 0;\r\n  text-align: left;\r\n  font: inherit;\r\n  font-size: var(--texto-md);\r\n  font-weight: 700;\r\n  line-height: 1.35;\r\n  color: var(--verde-institucional);\r\n  overflow-wrap: anywhere;\r\n  cursor: pointer;\r\n}\r\n\r\n.historico__cartao-selecionar:focus-visible {\r\n  outline: 2px solid var(--verde-primario);\r\n  outline-offset: 3px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.historico__cartao-campos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n  margin: 0;\r\n}\r\n\r\n.historico__cartao-campo {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n/* Rótulo com largura de conteúdo; valor ocupa o restante, alinhado à direita e\r\n   com quebra segura de identificadores extensos (nunca uma palavra por linha). */\r\n.historico__cartao-campo dt {\r\n  flex: none;\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.historico__cartao-campo dd {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  margin: 0;\r\n  text-align: right;\r\n  font-size: var(--texto-sm);\r\n  font-variant-numeric: tabular-nums;\r\n  color: var(--tinta);\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.historico__cartao-acoes {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-top: var(--espaco-3);\r\n  border-top: 1px solid var(--linha);\r\n}\r\n\r\n/* Até 760 px: troca a tabela pelos cartões. `display: none` remove a tabela da\r\n   árvore de acessibilidade, evitando conteúdo duplicado para leitores de tela. */\r\n@media (max-width: 760px) {\r\n  .historico__tabela-wrapper {\r\n    display: none;\r\n  }\r\n\r\n  .historico__cartoes {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--espaco-3);\r\n  }\r\n}\r\n\r\n/* --- Modal premium ------------------------------------------------------- */\r\n\r\n.modal__backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: var(--espaco-4);\r\n  background: color-mix(in srgb, var(--verde-institucional) 38%, transparent);\r\n  backdrop-filter: blur(2px);\r\n}\r\n\r\n.modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  max-width: 560px;\r\n  max-height: calc(100vh - var(--espaco-7));\r\n  background: var(--superficie);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-flutuante);\r\n  overflow: hidden;\r\n}\r\n\r\n.modal--compacto {\r\n  max-width: 440px;\r\n}\r\n\r\n.modal__cabecalho {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-4);\r\n  padding: var(--espaco-5) var(--espaco-5) var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.modal__cabecalho-textos {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-1);\r\n  min-width: 0;\r\n}\r\n\r\n.modal__titulo {\r\n  margin: 0;\r\n  font-size: var(--texto-lg);\r\n  font-weight: 700;\r\n  color: var(--verde-institucional);\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.modal__subtitulo {\r\n  margin: 0;\r\n  font-size: var(--texto-sm);\r\n  color: var(--tinta-media);\r\n}\r\n\r\n.modal__fechar {\r\n  flex: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  padding: 0;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--raio);\r\n  color: var(--tinta-suave);\r\n  cursor: pointer;\r\n  transition: background var(--transicao), color var(--transicao);\r\n}\r\n\r\n.modal__fechar:hover {\r\n  background: var(--superficie-2);\r\n  color: var(--tinta);\r\n}\r\n\r\n.modal__fechar svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.modal__corpo {\r\n  padding: var(--espaco-4) var(--espaco-5);\r\n  overflow-y: auto;\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n}\r\n\r\n.modal__acoes {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-3) var(--espaco-5) var(--espaco-5);\r\n  border-top: 1px solid var(--linha);\r\n  background: var(--superficie-2);\r\n}\r\n\r\n/* Detalhes da execução dentro do modal */\r\n.detalhe-execucao__grade {\r\n  display: grid;\r\n  grid-template-columns: max-content 1fr;\r\n  column-gap: var(--espaco-4);\r\n  row-gap: var(--espaco-3);\r\n  align-items: baseline;\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.detalhe-execucao__rotulo {\r\n  margin: 0;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.detalhe-execucao__valor {\r\n  margin: 0;\r\n  color: var(--tinta);\r\n  word-break: break-word;\r\n}\r\n\r\n.detalhe-execucao__valor--mono {\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-media);\r\n}\r\n\r\n.detalhe-execucao__evidencias {\r\n  margin: 0;\r\n  padding-left: var(--espaco-4);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.detalhe-execucao__evidencias li {\r\n  margin: var(--espaco-1) 0;\r\n}\r\n\r\n.detalhe-execucao__rodape-info {\r\n  margin: var(--espaco-4) 0 0;\r\n  padding-top: var(--espaco-3);\r\n  border-top: 1px solid var(--linha);\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.detalhe-execucao__erro {\r\n  margin: 0 0 var(--espaco-3);\r\n  padding: var(--espaco-3) var(--espaco-3);\r\n  background: #fbe6e4;\r\n  color: var(--erro);\r\n  border: 1px solid color-mix(in srgb, var(--erro) 24%, transparent);\r\n  border-radius: var(--raio);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n/* Modal de confirmação de exclusão: composição enxuta, sem cartões ou caixas\r\n   coloridas — o vermelho aparece apenas no ícone de alerta e no botão\r\n   destrutivo, o suficiente para comunicar o risco sem fragmentar o layout. */\r\n.confirmacao-exclusao__cabecalho {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  margin-bottom: var(--espaco-4);\r\n}\r\n\r\n.confirmacao-exclusao__alerta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: none;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: var(--raio);\r\n  background: #fbe6e4;\r\n  color: var(--erro);\r\n}\r\n\r\n.confirmacao-exclusao__alerta svg {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.confirmacao-exclusao__identificador {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  min-width: 0;\r\n}\r\n\r\n.confirmacao-exclusao__identificador-rotulo {\r\n  margin: 0;\r\n  font-size: var(--texto-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: var(--tinta-suave);\r\n}\r\n\r\n.confirmacao-exclusao__identificador-nome {\r\n  margin: 0;\r\n  font-size: var(--texto-md);\r\n  font-weight: 600;\r\n  color: var(--tinta);\r\n  word-break: break-word;\r\n}\r\n\r\n.confirmacao-exclusao__aviso {\r\n  margin: 0 0 var(--espaco-3);\r\n  color: var(--tinta-media);\r\n  font-size: var(--texto-sm);\r\n  line-height: 1.55;\r\n}\r\n\r\n.confirmacao-exclusao__aviso strong {\r\n  font-weight: 700;\r\n}\r\n\r\n.confirmacao-exclusao__erro {\r\n  margin: var(--espaco-3) 0 0;\r\n  padding: var(--espaco-3);\r\n  background: #fbe6e4;\r\n  color: var(--erro);\r\n  border: 1px solid color-mix(in srgb, var(--erro) 24%, transparent);\r\n  border-radius: var(--raio);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n.confirmacao-exclusao__atualizacao {\r\n  margin: var(--espaco-3) 0 0;\r\n  padding: var(--espaco-3);\r\n  background: var(--superficie-3);\r\n  color: var(--tinta-media);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n  font-size: var(--texto-sm);\r\n}\r\n\r\n/* --- Viewer em telas estreitas: sidebar compacta ------------------------- */\r\n\r\n@media (max-width: 760px) {\r\n  .casca-aplicacao:has(.palco) .casca-aplicacao__corpo {\r\n    grid-template-columns: 64px minmax(0, 1fr);\r\n  }\r\n\r\n  .casca-aplicacao:has(.palco) .barra-lateral {\r\n    width: 64px;\r\n    box-sizing: border-box;\r\n    padding: 12px 8px;\r\n  }\r\n\r\n  .casca-aplicacao:has(.palco) .barra-lateral__item {\r\n    justify-content: center;\r\n    padding: 8px;\r\n  }\r\n\r\n  .casca-aplicacao:has(.palco) .barra-lateral__rotulo {\r\n    display: none;\r\n  }\r\n\r\n  .casca-aplicacao:has(.palco) .barra-lateral__recolher {\r\n    display: none;\r\n  }\r\n\r\n  .casca-aplicacao:has(.palco) .casca-aplicacao__coluna {\r\n    min-width: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
